import { CustomerService } from '@appStore/customers/services/customer.service';

export const services: any[] = [CustomerService];

export * from '@appStore/customers/services/customer.service';
